export default "__VITE_ASSET__2iDsPTsS__"